import React, { useEffect, Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import BannerForm from 'Component/DashboardQeza/Banner/Form';
import { getBanner } from 'Services/Features/Banner/Utils/bannerUtils';
import { setFormData, resetFormData } from 'Services/Features/Banner/bannerSlice';

const BannerAdd = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const filters = useSelector(state => state.banner.filters)
    const currentBanner = useSelector((state) => state.banner.currentBanner);
    const [refetch, setRefetch] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        if (id && !currentBanner?.id) {
            // Buat filter untuk ambil data berdasarkan ID
            const newFilters = {
                ...filters,
                "filter[id]": id,
                page: 1,
            };

            // Fetch data dari API pakai ID
            dispatch(getBanner(newFilters)).then((response) => {
                if (response.payload && response.payload.data?.length > 0) {
                    const item = response.payload.data[0]; // Ambil item pertama (kalau ada)

                    // Simpan photos & banner ke state terpisah
                    dispatch(setFormData({ photoLink: item.photo }));

                    // Buat objek baru tanpa photos & banner
                    const { photo, ...updatedItem } = item;

                    dispatch(setFormData({
                        ...updatedItem,
                    }));
                }
            });
        } else if (currentBanner?.id) {
            // Kalau nggak ada ID, tapi ada data di state, pakai yang ada
            dispatch(setFormData({
                ...currentBanner,
            }));
        } else {
            // Kalau nggak ada ID & data di state, reset form
            dispatch(resetFormData());
        }
    }, [id, refetch]);



    return (
        <Fragment>
            <Breadcrumbs parent="Banner" title={id ? 'Edit Banner' : 'Tambah Banner'} />
            <BannerForm label={id ? "" : "Banner Baru"} setRefetch={setRefetch} />
        </Fragment>
    );
};
export default BannerAdd;